

export default class Tab {

    constructor(name, id) {
        this.name = name;
        this.id = id;
    }
}